import {UserGender} from "../../constant/user/UserGender"
import {ContentTargetDomain} from "../../domain/content/ContentTargetDomain"
import {ContentId} from "../../id/content/ContentId"
import {ContentTargetId} from "../../id/content/ContentTargetId"
import {EnvCountryId} from "../../id/env/EnvCountryId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 콘텐츠 노출 대상
 */
export class ContentTargetValueObject implements ValueObject, ContentTargetDomain {
    /**
     * 기본키
     */
    id: ContentTargetId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 콘텐츠 ID
     */
    contentId: ContentId
    /**
     * 국가 ID
     */
    envCountryId?: EnvCountryId
    /**
     * 성별
     */
    userGender?: UserGender
    /**
     * 출생년도 최소
     */
    userBirthYearMin?: number
    /**
     * 출생년도 최대
     */
    userBirthYearMax?: number
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date

    constructor(o: Record<keyof ContentTargetDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.contentId = BigInt(o.contentId)
        if (o.envCountryId !== undefined && o.envCountryId !== null) {
            this.envCountryId = BigInt(o.envCountryId)
        }
        if (o.userGender !== undefined && o.userGender !== null) {
            this.userGender = o.userGender as UserGender
        }
        if (o.userBirthYearMin !== undefined && o.userBirthYearMin !== null) {
            this.userBirthYearMin = Number(o.userBirthYearMin)
        }
        if (o.userBirthYearMax !== undefined && o.userBirthYearMax !== null) {
            this.userBirthYearMax = Number(o.userBirthYearMax)
        }
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
    }
}
